var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowRight06 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.4,
  fillRule: "evenodd",
  d: "m3.01 10 4-4-4-4L4 1.01 8.99 6 4 10.99z",
  clipRule: "evenodd"
})));
export default SvgIconArrowRight06;